import { UnknownAction, createAction } from "@reduxjs/toolkit";

export const broadcast = createAction(
  "broadcast",
  (...payload: UnknownAction[]) => ({
    payload,
  }),
);
